/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

export const SET_PROFILE_SHARE = '@@nzr/renterQuestions/SET_PROFILE_SHARE'
